import Vue from 'vue';
import i18n from "../../../i18n";

export default {
  async createEstimate({ commit }, payload) {
    return Vue.axios
      .post(Vue.$url("estimate"), payload)
      .then((rsp) => {
        Vue.$log.debug("estimate created and saved under", rsp.data.id);
        commit('mShowInfoMessage', i18n.t('common.saved', { 0: 'Estimate', 1: payload.description }), { root: true });
      })
  },

  async fetchEstimates({ commit }, { pId, vId, pvId }) {
    Vue.$log.debug('loading estimates for', pId, vId);

    let query = '?pId=' + (pId || '') + '&vId=' + (vId || '') + '&pvId=' + (pvId || '');
    return Vue.axios.get(Vue.$url("estimate" + query))
      .then((rsp) => commit('SET_ESTIMATES', rsp.data))
  },

  async fetchNextMaxCode({ commit }, { pId, vId }) {
    Vue.$log.debug('loading estimate next code for', pId, vId);
    let query = '?pId=' + (pId || '') + '&vId=' + (vId || '');
    return Vue.axios.get(Vue.$url("estimate/max-code" + query))
      .then((rsp) => {
        commit('SET_NEXT_SEQ_CODE', rsp.data);
        return rsp.data;
      })
  },

  async deleteEstimate({ dispatch, commit }, payload) {
    Vue.$log.debug('trying to delete estimate with id: ', payload.id);
    return Vue.axios
      .delete(Vue.$url("estimate/" + payload.id))
      .then(() => {
        dispatch('fetchEstimates');
        commit('mShowInfoMessage', i18n.t('common.lockupdate', { 0: payload.description }), { root: true });
      });
  },

  async updateEstimate({ dispatch, commit }, payload) {
    return Vue.axios
      .put(Vue.$url("estimate/" + payload.id), payload)
      .then(() => {
        dispatch('fetchEstimates');
        commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'Estimate', 1: payload.description }), { root: true });
      });
  },
}